module.exports = __webpack_public_path__ + "img/emoji_109.1fd4db7a.png";